"use strict";
var __awaiter =
  (this && this.__awaiter) ||
  function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function (resolve) {
            resolve(value);
          });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
var __generator =
  (this && this.__generator) ||
  function (thisArg, body) {
    var _ = {
        label: 0,
        sent: function () {
          if (t[0] & 1) throw t[1];
          return t[1];
        },
        trys: [],
        ops: [],
      },
      f,
      y,
      t,
      g;
    return (
      (g = { next: verb(0), throw: verb(1), return: verb(2) }),
      typeof Symbol === "function" &&
        (g[Symbol.iterator] = function () {
          return this;
        }),
      g
    );
    function verb(n) {
      return function (v) {
        return step([n, v]);
      };
    }
    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (_)
        try {
          if (
            ((f = 1),
            y &&
              (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) &&
              !(t = t.call(y, op[1])).done)
          )
            return t;
          if (((y = 0), t)) op = [op[0] & 2, t.value];
          switch (op[0]) {
            case 0:
            case 1:
              t = op;
              break;
            case 4:
              _.label++;
              return { value: op[1], done: false };
            case 5:
              _.label++;
              y = op[1];
              op = [0];
              continue;
            case 7:
              op = _.ops.pop();
              _.trys.pop();
              continue;
            default:
              if (!((t = _.trys), (t = t.length > 0 && t[t.length - 1])) && (op[0] === 6 || op[0] === 2)) {
                _ = 0;
                continue;
              }
              if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                _.label = op[1];
                break;
              }
              if (op[0] === 6 && _.label < t[1]) {
                _.label = t[1];
                t = op;
                break;
              }
              if (t && _.label < t[2]) {
                _.label = t[2];
                _.ops.push(op);
                break;
              }
              if (t[2]) _.ops.pop();
              _.trys.pop();
              continue;
          }
          op = body.call(thisArg, _);
        } catch (e) {
          op = [6, e];
          y = 0;
        } finally {
          f = t = 0;
        }
      if (op[0] & 5) throw op[1];
      return { value: op[0] ? op[1] : void 0, done: true };
    }
  };
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogMenu = void 0;
var DOMHelper_1 = require("./DOMHelper");
var global_1 = require("./global");
var inputCodePopup_1 = require("./inputCodePopup");
var sentry_1 = require("./sentry");
var textPopup_1 = require("./textPopup");
var LogMenu = /** @class */ (function () {
  function LogMenu() {
    var _this = this;
    //every item to display in menu
    this.items = [
      {
        title: "No log (default)",
        id: "sentry",
        onSelect: function () {
          localStorage.removeItem("logOutput");
          localStorage.removeItem("remoteCode");
          global_1.setLogOutput("sentry");
        },
      },
      {
        title: "Log to console",
        id: "console",
        onSelect: function () {
          localStorage.setItem("logOutput", "console");
          global_1.setLogOutput("console");
        },
      },
      {
        title: "Log to overlay",
        id: "overlay",
        onSelect: function () {
          localStorage.setItem("logOutput", "overlay");
          global_1.setLogOutput("overlay");
        },
      },
      {
        title: "Log to RemoteJS",
        id: "remoteJS",
        onSelect: function () {
          _this.codePopup = new inputCodePopup_1.InputCodePopup(
            "Input the room number for RemoteJS",
            function (code) {
              return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  localStorage.setItem("logOutput", "remoteJS");
                  localStorage.setItem("remoteCode", code);
                  global_1.setLogOutput("remoteJS", code);
                  new textPopup_1.TextPopup(
                    "console redirected to https://remotejs.com/viewer/" +
                      _LogContext.logConfig.remotePrefix +
                      "-" +
                      code,
                    4000
                  );
                  return [2 /*return*/];
                });
              });
            },
            function () {
              _this.codePopup = undefined;
            }
          );
        },
      },
      {
        title: "Log to console.re",
        id: "consoleRe",
        onSelect: function () {
          _this.codePopup = new inputCodePopup_1.InputCodePopup(
            "Input the room number for Console.re",
            function (code) {
              return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  localStorage.setItem("logOutput", "consoleRe");
                  localStorage.setItem("remoteCode", code);
                  global_1.setLogOutput("consoleRe", code);
                  new textPopup_1.TextPopup(
                    "console redirected to http://console.re/" + _LogContext.logConfig.remotePrefix + "-" + code,
                    4000
                  );
                  return [2 /*return*/];
                });
              });
            },
            function () {
              _this.codePopup = undefined;
            }
          );
        },
      },
      {
        title: "Send logs to Sentry",
        id: "sentry",
        onSelect: function () {
          _this.codePopup = new inputCodePopup_1.InputCodePopup(
            "Input a report code for Sentry",
            function (code) {
              sentry_1.reportSentryEvent("User Report " + code);
              new textPopup_1.TextPopup("User Report " + code + " sent to Sentry", 4000);
            },
            function () {
              _this.codePopup = undefined;
            }
          );
        },
      },
    ];
    this.domMenuItems = [];
    this.selectedItemIndex = 0;
    this.displayed = false;
    this.domTree = undefined;
    /**
     * call it when user navigate in menu
     */
    this.onKey = function (key, type) {
      if (type == "keyup") {
        // on keyup, we just check if we need to prevent the handling of the event (menu or popup showing)
        return _this.codePopup != undefined || _this.displayed || key === _this.lastBlockingKey;
      } else {
        if (_this.codePopup) {
          _this.codePopup.onKey(key);
          _this.lastBlockingKey = key;
          return true;
        } else {
          if (_LogContext.logConfig.menuTriggerSequences.length === 0) return false;
          _LogContext.logConfig.menuTriggerSequences.forEach(function (sequence, index) {
            if (key === sequence[_this.triggerSequenceIndexes[index]]) {
              _this.triggerSequenceIndexes[index]++;
            } else {
              _this.triggerSequenceIndexes[index] = 0;
            }
            if (_this.triggerSequenceIndexes[index] >= sequence.length) {
              _this.triggerSequenceIndexes[index] = 0;
              if (!_this.displayed) {
                // when showing, we'll block always
                _this.show();
              } else {
                // when hiding, block the keyup event
                _this.hide();
                _this.lastBlockingKey = key;
                return true;
              }
            }
          });
          if (_this.displayed) {
            switch (key) {
              case "ArrowDown":
                _this.selectedItemIndex + 1 < _this.items.length ? _this.selectedItemIndex++ : null;
                _this.updateSelectionCSS();
                break;
              case "ArrowUp":
                _this.selectedItemIndex - 1 >= 0 ? _this.selectedItemIndex-- : null;
                _this.updateSelectionCSS();
                break;
              case "Select":
              case "Enter":
                _this.items[_this.selectedItemIndex].onSelect();
                _this.hide();
                break;
              case "Backspace":
              case "Cancel":
              case "Escape":
                _this.hide();
                break;
              default:
                break;
            }
            _this.lastBlockingKey = key;
            return true;
          }
        }
        return false;
      }
    };
    /**
     * Show dsMenu
     */
    this.show = function () {
      if (!_this.displayed) {
        _this.buildDom();
        _this.updateSelectionCSS();
        _this.displayed = true;
      }
    };
    /**
     * Hide dsMenu
     */
    this.hide = function () {
      var _a;
      //remove dom
      (_a = _this.domTree) === null || _a === void 0 ? void 0 : _a.remove();
      //reset menu
      _this.selectedItemIndex = 0;
      _this.domMenuItems = [];
      //set state
      _this.displayed = false;
    };
    this.triggerSequenceIndexes = _LogContext.logConfig.menuTriggerSequences.map(function (_) {
      return 0;
    });
  }
  /**
   * call internally to create dsMenu. To create dsMenu call onShown
   */
  LogMenu.prototype.buildDom = function () {
    var _this = this;
    var _a, _b;
    var parent =
      (_b = document.getElementById((_a = _LogContext.logConfig.rootElementId) !== null && _a !== void 0 ? _a : "")) !==
        null && _b !== void 0
        ? _b
        : DOMHelper_1.DOMHelper.getBody();
    this.domTree = DOMHelper_1.DOMHelper.createDivWithParent(parent, "DSMenu");
    this.domTree.style.backgroundColor = _LogContext.logConfig.lightUI ? "#e7e7e7" : "#2a2a2a";
    var title = DOMHelper_1.DOMHelper.createDivWithParent(this.domTree, null, "item", "=> " + _LogContext.logOutput);
    title.style.padding = "10px";
    title.style.backgroundColor = "#888";
    parent.style.color = _LogContext.logConfig.lightUI ? "rgb(20, 20, 20)" : "rgb(252, 252, 252)";
    this.items.forEach(function (item) {
      var menuItem = DOMHelper_1.DOMHelper.createDivWithParent(_this.domTree, null, "item", item.title);
      menuItem.style.padding = "10px";
      _this.domMenuItems.push(menuItem);
    });
    //style
    this.domTree.style.position = "absolute";
    this.domTree.style.top = "0px";
    this.domTree.style.left = "0px";
    this.domTree.style.zIndex = "999";
    this.domTree.style.fontFamily = "Heebo, sans-serif";
  };
  /**
   * call internally to color selected index.
   */
  LogMenu.prototype.updateSelectionCSS = function () {
    this.domMenuItems.forEach(function (item) {
      item.style.backgroundColor = "";
    });
    this.domMenuItems[this.selectedItemIndex].style.backgroundColor = "red";
  };
  return LogMenu;
})();
exports.LogMenu = LogMenu;
//# sourceMappingURL=menu.js.map
